import { Pill } from '@baseV2'

// theme.colors.status key per status — shipment requests and fulfillment plans share this map
const STATUS_COLORS = {
	// shipment request
	ACTIVE: 'info',
	COMPLETED: 'success',
	CANCELLED: 'error',
	// fulfillment plan
	PENDING: 'warning',
	APPROVED: 'success',
	REJECTED: 'error',
}

// the status is shown in capitals, as the api sends it; anything unmapped falls back to the neutral chip
const StatusChip = ({ status }) => {
	if (!status) return '-'

	const label = status.replace(/_/g, ' ').toUpperCase()
	return (
		<Pill size='small' color={STATUS_COLORS[status] ?? 'neutral'}>
			{label}
		</Pill>
	)
}

export default StatusChip
